import { render, staticRenderFns } from "./SignEmbeddedDialog.vue?vue&type=template&id=1c98578b&scoped=true"
import script from "./SignEmbeddedDialog.vue?vue&type=script&lang=js"
export * from "./SignEmbeddedDialog.vue?vue&type=script&lang=js"
import style0 from "./SignEmbeddedDialog.vue?vue&type=style&index=0&id=1c98578b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c98578b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c98578b')) {
      api.createRecord('1c98578b', component.options)
    } else {
      api.reload('1c98578b', component.options)
    }
    module.hot.accept("./SignEmbeddedDialog.vue?vue&type=template&id=1c98578b&scoped=true", function () {
      api.rerender('1c98578b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/occurrence/SignEmbeddedDialog.vue"
export default component.exports